import {
  STANDARD_CONTENT_PAGE_KINDS,
  TENANT_ROLES,
  type ContentPageKind,
  type MeResponse,
  type StoreCapability,
  type TenantRole,
} from '@avrahami/contracts';

/** What the member may do in the active store (the API checks the same on every request). */
export function can(me: MeResponse | undefined, capability: StoreCapability): boolean {
  return me?.activeTenant?.capabilities.includes(capability) ?? false;
}

/**
 * Roles a member may hand out: owners any, admins anyone but an owner (TENANT_ADMIN.md: an admin
 * cannot touch owners).
 */
export function assignableRoles(actor: TenantRole): readonly TenantRole[] {
  return actor === 'TENANT_OWNER'
    ? TENANT_ROLES
    : TENANT_ROLES.filter((role) => role !== 'TENANT_OWNER');
}

/** Whether the actor may change or remove a member: never themselves, and admins never owners. */
export function canManageMember(actor: TenantRole, target: TenantRole, isSelf: boolean): boolean {
  if (isSelf) return false;
  return actor === 'TENANT_OWNER' || target !== 'TENANT_OWNER';
}

/** Standard pages the store does not have yet (offered as one-click "create"). */
export function missingStandardPages(
  pages: readonly { kind: ContentPageKind }[],
): ContentPageKind[] {
  const present = new Set(pages.map((page) => page.kind));
  return STANDARD_CONTENT_PAGE_KINDS.filter((kind) => !present.has(kind));
}
